/* eslint-disable camelcase */

export const organismNames = [
  'Homo sapiens',
  'Caenorhabditis elegans',
  'Danio rerio',
  'Drosophila melanogaster',
  'Mus musculus',
  'Saccharomyces cerevisiae',
] as const;
export const organismSlugs: OrganismSlugString[] = [
  'homo-sapiens',
  'caenorhabditis-elegans',
  'danio-rerio',
  'drosophila-melanogaster',
  'mus-musculus',
  'saccharomyces-cerevisiae',
];

export enum Organisms {
  'homo-sapiens' = 'Homo sapiens',
  'caenorhabditis-elegans' = 'Caenorhabditis elegans',
  'danio-rerio' = 'Danio rerio',
  'drosophila-melanogaster' = 'Drosophila melanogaster',
  'mus-musculus' = 'Mus musculus',
  'saccharomyces-cerevisiae' = 'Saccharomyces cerevisiae',
}

export type OrganismNameString = typeof organismNames[number];
export type OrganismSlugString = keyof typeof Organisms;
export type EmptyObject = Record<string, never>;
export type GeneMatch = {
  aliases: string;
  description: string;
  entrez: number;
  organism: OrganismSlugString;
  score: number;
  standard_name: string;
  xrefs: string;
};
export type GeneDefinition = {
  query: string;
  num_matches: number;
  matches: GeneMatch[];
};
export type GeneMatchLookUp = {
  [key: string]: GeneMatch;
};
export type TissueNetwork = {
  context: {
    term: Term;
    title: string;
    url: string;
    version?: {
      identifier: string;
    };
  };
  slug: string;
  url: string;
};

export type EntrezLookup = {
  [key: string]: string;
};
export type Term = {
  database: Database;
  label: string;
  value: string;
  identifier: string; // Primary identifier used for indexing and referencing
  datasets?: number;
};
export type Database = {
  annotation_version: string;
  name: string;
  slug: string;
  term_version: string;
  url: string;
};
export type Datatype = {
  title: string;
  slug: string;
  description?: string;
  count?: number;
};

export type CrossRef = {
  // Define CrossRef properties based on API usage
  database: string;
  identifier: string;
  url?: string;
};

// Canonical Gene interface based on HumanBase API specification
export interface Gene {
  url: string;
  entrez: number; // Primary identifier - Unique NCBI Entrez ID
  systematic_name: string;
  standard_name?: string; // nullable in API
  description: string;
  xrefs: CrossRef[];
  aliases: string[];
}

// Network-related types used across multiple components
export interface NetworkId {
  group: string;
  idx: number;
}

export interface NetworkData {
  genes?: Gene[];
  error?: string;
}

export interface NetworkState {
  isFetching: boolean;
  data?: NetworkData;
  selectedIntegration?: TissueNetwork; // Full TissueNetwork object (not URL string)
  selectedDatatypes?: Datatype[]; // Array of Datatype objects (not strings)
  selectedGenes?: Gene[]; // Array of Gene objects
}

// Simple history type for navigation
export interface History {
  push: (path: string) => void;
}

// Community result query payload — backend snake_case wire format.
export interface CommunityResultQuery {
  entrez_list?: string[];
  integration?: string;
  giant_version?: string;
  title?: string | null;
  extended_universe?: boolean;
}
